import React from "react";
import { withStyles } from "material-ui/styles";
import classnames from "classnames";

const styles = {};

const CTableHead = props => {
  const { children, classes, className, ...otherProps } = props;

  return (
    <thead {...otherProps} className={classnames(className)}>
      {children}
    </thead>
  );
};

export default withStyles(styles)(CTableHead);



// WEBPACK FOOTER //
// ./src/uis/CTable/CTableHead.jsx